import gql from 'graphql-tag'
import moment from 'moment'
import paramExtractor from '@/assets/modules/channels/paramExtractor'
import dc from '@/assets/modules/events/discountCalculator'
import { toInternalForm } from '@/assets/modules/events/discountCalculator'
import { isDiscountMpe } from '@/assets/modules/error/resolver'

export default {
  data () {
    return {
      campaigns: {}
    }
  },

  computed: {
    /**
     * Gives an array of campaigns
     * @returns {Array}
     */
    getData () {
      return (this.campaigns.set || [])[0] || {}
    },

    /**
     * Gives campaign's meta fields
     * @returns {Object}
     */
    getCampaignMeta () {
      return this.getData.meta || {}
    },

    /**
     * Gives extracted campaign params
     * @returns {Object}
     */
    getCampaignInfo () {
      let campaign = this.getData

      return {
        id: campaign.id,
        label: campaign.label,
        startsAt: campaign.startsAt,
        expiresAt: campaign.expiresAt,
        status: campaign.status,
        type: campaign.type
      }
    },

    /**
     * Gives an array of campaign events
     * @returns {Array}
     */
    getCampaignEvents () {
      let campaign = this.getData

      let rtr = {}
      let events = ((campaign.events || {}).set || []).filter(e => !isDiscountMpe(e.type))

      for (let e of events) {
        const { advertisable, publishAt, credentials, id } = e
        let payload = { ...(e.payload || {}) }

        const image = (((advertisable.media || {}).set || [])[0] || {}).url

        const params = paramExtractor.extract(credentials.type)
        const icon = { name: params.icon, pack: params.pack }

        const date = moment(publishAt).format('DD. MM. YYYY')
        if (!rtr[date]) {
          rtr[date] = []
        }

        // Correct payload's discount
        payload.discount = toInternalForm(payload.discount, e.type).discount

        rtr[date].push({
          id,
          image,
          label: advertisable.label,
          price: dc.calculate(payload, advertisable.meta, this.getCampaignMeta),
          icon,
          channel: credentials.label || credentials.meta.viewUrl,
          time: publishAt
        })

        rtr[date].sort(function (a, b) {
          return moment(b.time).isBefore(moment(a.time))
        })
      }

      return rtr
    }
  },

  // Apollo...
  apollo: {
    campaigns: {
      query: gql`query ($id: [UUID!]) {
        campaigns (id: $id) {
          set {
            id,
            label,
            startsAt,
            expiresAt,
            status,
            type,
            meta {
              ... on CampaignDailyDeal {
                discount
              },
              ... on CampaignSale {
                discount
              }
            },

            events {
              set {
                type,
                id,
                publishAt
                credentials {
                  id,
                  type,
                  label,
                  meta {
                    ... on UserCredentialsSqwizPage {
                      viewUrl
                    }
                  }
                }
                payload {
                  ... on MediaPlanEventSqwizProduct {
                    discount: discountPercent,
                    price
                  },
                  ... on MediaPlanEventShopamineProduct {
                    discount,
                    price
                  },
                  ... on MediaPlanEventInformacijaProduct {
                    discount,
                    price
                  }
                },
                advertisable {
                  id,
                  label,
                  meta {
                    ... on AdvertisableImportedProduct {
                      price
                      discount
                    }
                    ... on  AdvertisableProduct{
                      price,
                      discount
                    }
                  }
                  media {
                    set {
                      url
                    }
                  }
                }
              }
            }
          }
        }
      }`,
      variables () {
        return {
          id: [this.getCampaignId],
        }
      },
      fetchPolicy: 'cache-and-network'
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/pagination/providers/campaignPreview.js